import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';

import Events from './events';
import Casino from './casino';

import Homepage from '../containers/homepage/Homepage';
import { PRODUCTS } from '../constants';
import NotFound from '../components/NotFound';

const ProductRoutes = ({ match: { url = '' } }) => (
  <Switch>
    <Route path={`${url}/events`} component={Events} />

    <Route
      path="/live-casino/:lobbyId?"
      render={() => (
        <Casino product={PRODUCTS.liveCasino} />
      )}
    />

    <Route
      path="/casino/:lobbyId?"
      render={() => (
        <Casino product={PRODUCTS.casino} />
      )}
    />


    <Route
      path="/virtuals/:lobbyId?"
      render={() => (
        <Casino product={PRODUCTS.virtuals} />
      )}
    />

    <Route exact path={`${url}/(bonuses|registration|login|reset-password)?`} component={Homepage} />

    <Route component={NotFound} />
  </Switch>
);

ProductRoutes.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default ProductRoutes;

